import { DRIVE_APP_DOWNLOAD_URLS } from '@frameio/shared/resources/mounted-storage/constants';
import type { BulkActions } from './types';

export { DRIVE_APP_DOWNLOAD_URLS };

export const RENAME_ASSET_MAX_LENGTH = 255;
export const OPTIMISTIC_FOLDER_ID = 'new-folder-id';
export const INVALID_TARGET_PROJECT_REASON = 'invalid_target_project';

export const BULK_ASSET_OPERATION_ASSET_COUNT_LIMIT = 1000;

export const MaxAssetCountPerBulkAction: { [k in BulkActions]: number } = {
  move: BULK_ASSET_OPERATION_ASSET_COUNT_LIMIT,
  copy: BULK_ASSET_OPERATION_ASSET_COUNT_LIMIT,
  delete: BULK_ASSET_OPERATION_ASSET_COUNT_LIMIT,
  duplicate: BULK_ASSET_OPERATION_ASSET_COUNT_LIMIT,
  editField: BULK_ASSET_OPERATION_ASSET_COUNT_LIMIT,
  hardDelete: BULK_ASSET_OPERATION_ASSET_COUNT_LIMIT,
};

export enum CopyCommentsOptions {
  // none of them
  NONE = 'NONE',
  // all of them
  ALL = 'ALL',
  // only private
  PRIVATE = 'PRIVATE',
  // only public
  PUBLIC = 'PUBLIC',
  // includes only parent level comments and excludes siblings (replies)
  INITIAL = 'INITIAL',
  // just the ones not marked complete
  INCOMPLETE = 'INCOMPLETE',
}

export const CopyCommentsFilterOptions = {
  ALL: 'AllComments',
  PRIVATE: 'PrivateComments',
  PUBLIC: 'PublicComments',
};

export const DRIVE_PROTOCOL_URL_PREFIX = 'frameio-drive://';
export const TRANSFER_PROTOCOL_URL_PREFIX = 'frameio-transfer://';

const TRANSFER_APP_BASE_URL =
  'https://transferapp.frame.io/Frame.io-Transfer/6ab0c27d61d7cf8793b0357e6533ed81/latest';
export const TRANSFER_APP_DOWNLOAD_URLS = {
  mac: `${TRANSFER_APP_BASE_URL}/darwin/x64/Frame.io+Transfer.dmg`,
  windows: `${TRANSFER_APP_BASE_URL}/win32/x64/Frame.io+Transfer.exe`,
};
